import React from 'react';

const overlayStyle = {
    position: 'fixed',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    width: '100%',
    height: '100%',
    zIndex: 2,
    cursor: 'pointer',
    background: 'black',
    opacity: '.5',
}

const spinnerStyle = {
    position: 'relative',
    left: '50%',
    top: '50%'
}

const Loader = () => {

    return (
        <div style={overlayStyle}>
            <div style={spinnerStyle} className="spinner-border text-light" role="status">
            </div>
        </div>
    )
}

export default (Loader);